
<div class="UserOrdersFilters">
  <b-message v-if="error" type="is-danger" size="is-small">
    {{ error }}
  </b-message>

  <div class="UserOrdersFilters__fields">
    <b-field label="Data od" :type="error ? 'is-danger' : null">
      <b-input
          type="date"
          :value="value.dateFrom"
          :disabled="isLoading"
          @input="update('dateFrom', $event)"
      />
    </b-field>

    <b-field label="Data do" :type="error ? 'is-danger' : null">
      <b-input
          type="date"
          :value="value.dateTo"
          :disabled="isLoading"
          @input="update('dateTo', $event)"
      />
    </b-field>

    <b-field label="Status">
      <b-select
          placeholder="Wszystkie"
          :value="value.status"
          :disabled="isLoading"
          expanded
          @input="update('status', $event)"
      >
        <option value="">Wszystkie</option>
        <option v-for="status in statusOptions" :key="status.value" :value="status.value">
          {{ status.label }}
        </option>
      </b-select>
    </b-field>
  </div>

  <div class="UserOrdersFilters__actions">
    <button
        type="button"
        class="button is-small is-primary"
        :class="{ 'is-loading': isLoading }"
        :disabled="isLoading"
        @click="$emit('submit')"
    >
      Filtruj
    </button>
    <button
        type="button"
        class="button is-small is-light"
        :disabled="isLoading"
        @click="$emit('clear')"
    >
      Wyczyść
    </button>
  </div>
</div>
